<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>
		<a-form layout="inline">
			<a-form-item label="指南标题">
				<a-input v-model="filterData.keywords" placeholder = "请输入关键字/ID" />
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>
				<a-button class="mr12" v-if="hasPermission('COMPLAINTGUIDE_SCRIPT')" @click="scriptEdit">话术编辑</a-button>
				<a-dropdown :trigger="['click']" v-if="hasPermission('COMPLAINTGUIDE_ADD')">
					<a-button>新建 <a-icon type="down" /></a-button>
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item key="COMPLAINT_GUIDE">投诉指南</a-menu-item>
						<a-menu-item key="FAQ">常见问题</a-menu-item>
						<a-menu-item key="COMPLAINT_CHANNEL">官方投诉渠道</a-menu-item>
					</a-menu>
				</a-dropdown>
			</a-form-item>
		</a-form>
		<div style="margin-top: 16px;margin-bottom: 16px;">
			<a-radio-group v-model="filterData.complaintGuideType" button-style="solid" @change="changeTab">
				<a-radio-button style="width: 150px;text-align: center;" value="COMPLAINT_GUIDE">投诉指南</a-radio-button>
				<a-radio-button style="width: 150px;text-align: center;" value="FAQ">常见问题</a-radio-button>
				<a-radio-button style="width: 250px;text-align: center;" value="COMPLAINT_CHANNEL">官方投诉渠道</a-radio-button>
			</a-radio-group>
		</div>
		<a-table
			:columns="columns"
			:data-source="tableData"
			:pagination="pageInfo"
			@change="changePage"
			:loading="loading"
			row-key="complaintGuideId"
		>
			<template slot="implementationStatusRender" slot-scope="text, record">
				<a-tag color="green" v-if="record.implementationStatus == 'ACTIVE'">
					现行有效
				</a-tag>
				<a-tag color="#afa" v-else-if="record.implementationStatus == 'PENDING'">
					即将实施
				</a-tag>
				<a-tag color="#898989" v-else-if="record.implementationStatus == 'OBSOLETE'">
					已废止
				</a-tag>
				<a-tag v-else></a-tag>
			</template>

<template slot="complaintChannelTypeRender" slot-scope="text, record">
				<a-tag color="green" v-if="record.complaintChannelType == 'TEL'">
					官网热线
				</a-tag>
				<a-tag color="#afa" v-else-if="record.complaintChannelType == 'WEB'">
					官网网站
				</a-tag>
				<a-tag v-else></a-tag>
			</template>


			<template slot="standardStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.complaintGuideStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.complaintGuideStatus === true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.complaintGuideStatus === false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>
			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span v-if="hasPermission('COMPLAINTGUIDE_EDIT')"><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link" v-if="hasPermission('COMPLAINTGUIDE_DEL')">删除</a-button>
					</a-popconfirm>
				</div>
			</template>
		</a-table>

		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="handleGuideCancel">
			<a-form-model ref="formRef" :model="editModel" :rules="rules">
				<a-row :gutter="20">
					<a-col :span="24">
						<a-form-model-item label="指南标题" prop="guideTitle" required>
							<a-input v-model="editModel.guideTitle" placeholder="请输入指南标题（如：如何准备投诉材料）" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="操作步骤" prop="operationSteps" required>
							<div ref="wangEditorGuide"></div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="发布状态" prop="complaintGuideStatus">
							<a-switch :checked="editModel.complaintGuideStatus"
								@change="(checked) => editModel.complaintGuideStatus = checked" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="排序" prop="sort">
							<a-input v-model.number="editModel.sort" placeholder="显示顺序" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>

		<a-modal :title="faqModel.title" :visible="faqModel.flag" width="700px" @ok="faqModel.onOk"
			@cancel="faqModel.flag = false">
			<a-form-model ref="formRef" :model="faqModel" :rules="rules">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="常见问题" prop="guideTitle" required>
							<a-input v-model="faqModel.guideTitle" placeholder="请输入常见问题（如：投诉之后多久能处理）" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="答案" prop="operationSteps" required>
							<div ref="wangEditorFaq"></div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="发布状态" prop="complaintGuideStatus">
							<a-switch :checked="faqModel.complaintGuideStatus"
								@change="(checked) => faqModel.complaintGuideStatus = checked" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="排序" prop="sort">
							<a-input v-model.number="faqModel.sort" placeholder="显示顺序" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>

		<a-modal :title="channelModel.title" :visible="channelModel.flag" width="700px" @ok="channelModel.onOk"
			@cancel="channelModel.flag = false">
			<a-form-model ref="formRef" :model="channelModel" :rules="rules">
				<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="渠道分类" prop="complaintChannelType" required>
							<a-select v-model="channelModel.complaintChannelType" class="mr12" placeholder="请选择渠道分类" show-search
								option-filter-prop="name" :filter-option="filterOption" @change="handleChannelTypeChange">
								<a-select-option v-for="(item, index) of tags" :key="index" :value="item.tagId">
									{{ item.tagName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item prop="complaintChannelValue" required>
							<span slot="label">{{ channelValueLabel }}</span>
							<a-input v-model="channelModel.complaintChannelValue" :placeholder="channelValuePlaceholder" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="渠道名称" prop="guideTitle" required>
							<a-input v-model="channelModel.guideTitle"
								placeholder="请输入渠道名称（例如：12315消费者投诉热线；全国12315平台）" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="服务时间" prop="serviceTime" required>
							<a-input v-model="channelModel.serviceTime"
								placeholder="请输入服务时间（例如：24小时服务；工作日：9:00-17:00）" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="服务描述" prop="operationSteps" required>
							<a-textarea v-model="channelModel.operationSteps" rows="4" placeholder="请对服务简短说明" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="发布状态" prop="complaintGuideStatus">
							<a-switch :checked="channelModel.complaintGuideStatus"
								@change="(checked) => channelModel.complaintGuideStatus = checked" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="排序" prop="sort">
							<a-input v-model.number="channelModel.sort" placeholder="显示顺序" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>

		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>投诉指南顶部：</div>
			<div><a-input v-model="tipsModel.topTitle" placeholder="标题" /></div>
			<div><a-textarea v-model="tipsModel.topContent" placeholder="内容" :rows="3" /></div>
			<div style="margin-top:10px">投诉指南底部：</div>
			<div><a-input v-model="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-textarea v-model="tipsModel.bottomContent" placeholder="内容" :rows="3" /></div>
		</a-modal>
	</div>
</template>

<script>
	import E from 'wangeditor';
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		importExecutionStandardApi,
		getComplaintGuideListApi,
		getComplaintGuideDetailApi,
		saveComplaintGuideApi,
		deleteComplaintGuideApi,
		updateComplaintGuideStatusApi,
		updateComplaintGuideSortApi,
	getBottomWordingApi, //  页面话术编辑 获取
	saveBottomWordingApi, //  页面话术编辑 保存
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'],
							['clean']
						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				rules: {
					complaintChannelType: [
						{ required: true, message: '请选择渠道分类', trigger: 'change' }
					],
					complaintChannelValue: [
						{ required: true, message: '请输入渠道联系方式', trigger: 'blur' }
					],
					serviceTime: [
						{ required: true, message: '请输入服务时间', trigger: 'blur' }
					],
					guideTitle: [
						{ required: true, message: '请输入指南标题', trigger: 'blur' }
					],
					operationSteps: [
						{ required: true, message: '请输入内容', trigger: 'blur' }
					]
				},
				editorGuide: null,
				editorFaq: null,
				commodityStatusList: [{
						label: "现行有效",
						value: 'ACTIVE',
					},
					{
						label: "即将实施",
						value: 'PENDING',
					},
					{
						label: "已废止",
						value: 'OBSOLETE',
					},
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					topTitle: "",
					topContent: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'COMPLAINT',
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					complaintGuideId: '',
					guideTitle: '',
					operationSteps: '',
					complaintGuideStatus: true,
					sort: 0,
					complaintGuideType: 'COMPLAINT_GUIDE',
					onOk: () => {},
				},
				// 常见问题 默认发布状态 true
				faqModel: {
					flag: false,
					title: '新增常见问题',
					complaintGuideId: '',
					guideTitle: '',
					operationSteps: '',
					complaintGuideStatus: true,
					sort: 0,
					complaintGuideType: 'FAQ',
					onOk: () => {},
				},
				// 官方投诉渠道 默认发布状态 true
				channelModel: {
					flag: false,
					title: '新增官方投诉渠道',
					complaintGuideId: '',
					complaintChannelType: undefined,
					complaintChannelValue: '',
					guideTitle: '',
					serviceTime: '',
					operationSteps: '',
					complaintGuideStatus: true,
					sort: 0,
					complaintGuideType: 'COMPLAINT_CHANNEL',
					onOk: () => {},
				},
				formState: {
					"iconUrl": "",
					"name": "",
					"sort": 1
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					complaintGuideType: 'COMPLAINT_GUIDE',
					lang: "CH",
				},
channelValueLabel: '渠道热线',
				channelValuePlaceholder: '请输入渠道热线，例如：12315',
				tags: [{
						tagId: 'TEL',
						tagName: "官方热线"
					},
					{
						tagId: 'WEB',
						tagName: "官方网站"
					}
				],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
				columnsMap: {
					COMPLAINT_GUIDE: [{
							title: 'ID',
							dataIndex: 'complaintGuideCode',
							key: 'complaintGuideCode'
						}, {
							title: '指南标题',
							dataIndex: 'guideTitle',
							key: 'guideTitle'
						},
						{
							title: '发布状态',
							dataIndex: 'complaintGuideStatus',
							key: 'complaintGuideStatus',
							scopedSlots: {
								customRender: 'standardStatusRender'
							}
						},
						{
							title: '创建时间',
							dataIndex: 'createTime',
							key: 'createTime'
						},
						{
							title: '排序',
							dataIndex: 'sort',
							key: 'sort',
							scopedSlots: {
								customRender: 'indexSortender'
							}
						},
						{
							title: '操作',
							key: 'action',
							scopedSlots: {
								customRender: 'action'
							}
						}
					],
					FAQ: [{
							title: 'ID',
							dataIndex: 'complaintGuideCode',
							key: 'complaintGuideCode'
						}, {
							title: '问题',
							dataIndex: 'guideTitle',
							key: 'guideTitle'
						},
						{
							title: '发布状态',
							dataIndex: 'complaintGuideStatus',
							key: 'complaintGuideStatus',
							scopedSlots: {
								customRender: 'standardStatusRender'
							}
						},
						{
							title: '创建时间',
							dataIndex: 'createTime',
							key: 'createTime'
						},
						{
							title: '排序',
							dataIndex: 'sort',
							key: 'sort',
							scopedSlots: {
								customRender: 'indexSortender'
							}
						},
						{
							title: '操作',
							key: 'action',
							scopedSlots: {
								customRender: 'action'
							}
						}
					],
					COMPLAINT_CHANNEL: [{
							title: 'ID',
							dataIndex: 'complaintGuideCode',
							key: 'complaintGuideCode'
						}, {
							title: '官方渠道名称',
							dataIndex: 'guideTitle',
							key: 'guideTitle'
						}, {
							title: '渠道类型',
							dataIndex: 'complaintChannelType',
							key: 'complaintChannelType',
							scopedSlots: {
								customRender: 'complaintChannelTypeRender'
							}
						},
						{
							title: '发布状态',
							dataIndex: 'complaintGuideStatus',
							key: 'complaintGuideStatus',
							scopedSlots: {
								customRender: 'standardStatusRender'
							}
						}, {
							title: '创建时间',
							dataIndex: 'createTime',
							key: 'createTime'
						},
						{
							title: '排序',
							dataIndex: 'sort',
							key: 'sort',
							scopedSlots: {
								customRender: 'indexSortender'
							}
						},
						{
							title: '操作',
							key: 'action',
							scopedSlots: {
								customRender: 'action'
							}
						}
					]
				}
			};
		},
		computed: {
			columns() {
				const type = this.filterData.complaintGuideType
				return this.columnsMap[type] || []
			}
		},
		created() {},
		activated() {},
		mounted() {
			this.getData(1)
			this.getTagsLabel()
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},
			handleMenuClick({ key }) {
				switch (key) {
					case 'COMPLAINT_GUIDE':
						this.toAdd();
						break;
					case 'FAQ':
						this.openFaqModal();
						break;
					case 'COMPLAINT_CHANNEL':
						this.openChannelModal();
						break;
				}
			},

			openFaqModal() {
				this.destroyEditorFaq();
				this.faqModel = {
					flag: true,
					title: "新增常见问题",
					complaintGuideId: '',
					guideTitle: '',
					operationSteps: '',
					complaintGuideStatus: true,
					complaintGuideType: 'FAQ',
					sort: null,
					onOk: this.saveFaq
				};
				this.$nextTick(() => {
					this.initEditorFaq();
				});
			},
			saveFaq() {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return;
					this.destroyEditorFaq();
					saveComplaintGuideApi({
						complaintGuideId: this.faqModel.complaintGuideId || 0,
						guideTitle: this.faqModel.guideTitle,
						operationSteps: this.faqModel.operationSteps,
						complaintGuideStatus: this.faqModel.complaintGuideStatus,
						sort: this.faqModel.sort,
						complaintGuideType: 'FAQ',
					}).then((res) => {
						if (res.resultStatus) {
							this.$message.success(this.faqModel.complaintGuideId ? "编辑成功" : "新增成功");
							this.faqModel.flag = false;
							this.getData(this.pageInfo.current);
						}
					}).catch(err => console.error(err));
				});
			},

			openChannelModal() {
				this.channelModel = {
					flag: true,
					title: "新增官方投诉渠道",
					complaintGuideId: '',
					complaintChannelType: undefined,
					complaintChannelValue: '',
					guideTitle: '',
					serviceTime: '',
					operationSteps: '',
					complaintGuideStatus: true,
					sort: null,
					complaintGuideType: 'COMPLAINT_CHANNEL',
					onOk: this.saveChannel
				};
			},
			saveChannel() {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return;
					let params = {
						complaintGuideId: this.channelModel.complaintGuideId || 0,
					complaintChannelType: this.channelModel.complaintChannelType,
					complaintChannelValue: this.channelModel.complaintChannelValue,
					guideTitle: this.channelModel.guideTitle,
					serviceTime: this.channelModel.serviceTime,
					operationSteps: this.channelModel.operationSteps,
					complaintGuideStatus: this.channelModel.complaintGuideStatus,
					sort: this.channelModel.sort,
					complaintGuideType: 'COMPLAINT_CHANNEL',
				}
				saveComplaintGuideApi(params).then((res) => {
					if (res.resultStatus) {
						this.$message.success(this.channelModel.complaintGuideId ? "编辑成功" : "新增成功");
						this.channelModel.flag = false;
						this.getData(this.pageInfo.current);
					}
				}).catch(err => console.error(err));
				});
			},

			handleChannelTypeChange(value) {
				const tag = this.tags.find(t => t.tagId === value);
				if (tag) {
					if (tag.tagId === 'TEL') {
						this.channelValueLabel = '渠道热线';
						this.channelValuePlaceholder = '请输入渠道热线，例如：12315';
					} else if (tag.tagId === 'WEB') {
						this.channelValueLabel = '渠道网站';
						this.channelValuePlaceholder = '请输入渠道网址，例如：https://www.example.com';
					}
				}
			},
			handlePublishChange(checked, record) {
				const content = checked
					? '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？'
					: '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				this.$confirm({
					title: '操作确认',
					content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						updateComplaintGuideStatusApi({
							complaintGuideId: record.complaintGuideId,
							complaintGuideStatus: checked
						}).then(res => {
							if (res.resultStatus) {
								this.$message.success("修改成功");
								this.getData(this.pageInfo.current);
							}
						}).catch(err => console.error(err));
					}
				});
			},

			handleSaveSort(record) {
				if (record.sort === undefined || record.sort === null || record.sort === '') return
				updateComplaintGuideSortApi({
					complaintGuideId: record.complaintGuideId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current)
					} else {
						this.$message.error('保存失败')
					}
				}).catch(() => this.$message.error('保存失败'))
			},

			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1);
			},
			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1);
			},

			getTagsLabel() {},

			filterOption(input, option) {
				return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						complaintGuideType: 'COMPLAINT_GUIDE',
						lang: "CH",
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) return;
				this.loading = true;
				getComplaintGuideListApi({
					pageNo: this.pageInfo.current,
					pageSize: this.pageInfo.pageSize,
					lang: this.filterData.lang,
					keywords: this.filterData.keywords,
					complaintGuideType: this.filterData.complaintGuideType
				}).then((res) => {
					if (res.resultStatus) {
						this.tableData = res.resultData.dataList || [];
						this.pageInfo.total = res.resultData.totalNum || 0;
					} else {
						this.tableData = [];
						this.pageInfo.total = 0;
					}
				}).catch((err) => {
					console.error(err);
				}).finally(() => {
					this.loading = false;
				});
			},
			toAdd() {
				this.destroyEditorGuide();
				this.editModel = {
					flag: true,
					title: "新增投诉指南",
					complaintGuideId: '',
					guideTitle: '',
					operationSteps: '',
					complaintGuideStatus: true,
					sort: null,
					complaintGuideType: 'COMPLAINT_GUIDE',
					onOk: this.sureEdit,
				};
				this.$nextTick(() => {
					this.initEditorGuide();
				});
			},
			toEdit(data) {
				getComplaintGuideDetailApi({
					complaintGuideId: data.complaintGuideId,
				}).then((res) => {
					if (res.resultStatus) {
						const result = res.resultData;
						if (result.complaintGuideType === 'FAQ') {
							this.faqModel = {
								flag: true,
								title: "编辑常见问题",
								complaintGuideId: result.complaintGuideId,
								guideTitle: result.guideTitle || '',
								operationSteps: result.operationSteps || '',
								complaintGuideStatus: !!result.complaintGuideStatus,
								sort: result.sort ?? null,
								complaintGuideType: 'FAQ',
								onOk: this.saveFaq
							}
							this.$nextTick(() => {
								this.initEditorFaq();
								this.$refs.formRef && this.$refs.formRef.clearValidate();
							});
						} else if (result.complaintGuideType === 'COMPLAINT_CHANNEL') {
							this.channelModel = {
								flag: true,
								title: "编辑官方投诉渠道",
								complaintGuideId: result.complaintGuideId,
								complaintChannelType: result.complaintChannelType || undefined,
								complaintChannelValue: result.complaintChannelValue || '',
								guideTitle: result.guideTitle || '',
								serviceTime: result.serviceTime || '',
								operationSteps: result.operationSteps || '',
								complaintGuideStatus: !!result.complaintGuideStatus,
								sort: result.sort ?? null,
								complaintGuideType: 'COMPLAINT_CHANNEL',
								onOk: this.saveChannel
							}
						} else {
							this.destroyEditorGuide();
							this.editModel = {
								flag: true,
								title: "编辑投诉指南",
								complaintGuideId: result.complaintGuideId,
								guideTitle: result.guideTitle || '',
								operationSteps: result.operationSteps || '',
								complaintGuideStatus: !!result.complaintGuideStatus,
								sort: result.sort ?? null,
								complaintGuideType: 'COMPLAINT_GUIDE',
								onOk: this.sureEdit,
							};
							this.$nextTick(() => {
								this.initEditorGuide();
								this.$refs.formRef && this.$refs.formRef.clearValidate();
							});
						}
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			sureEdit() {
				this.$refs.formRef.validate((valid) => {
					if (valid) {
						this.destroyEditorGuide();
						saveComplaintGuideApi({
							complaintGuideId: this.editModel.complaintGuideId || 0,
							guideTitle: this.editModel.guideTitle,
							operationSteps: this.editModel.operationSteps,
							complaintGuideStatus: this.editModel.complaintGuideStatus,
							sort: this.editModel.sort,
							complaintGuideType: 'COMPLAINT_GUIDE',
						}).then((res) => {
							if (res.resultStatus) {
								this.$message.success(this.editModel.complaintGuideId ? "编辑成功" : "新增成功");
								this.editModel.flag = false;
								this.getData(this.pageInfo.current);
							}
						}).catch((error) => {
							console.log(error);
						});
					}
				});
			},
			initEditorGuide() {
				this.$nextTick(() => {
					if (this.$refs.wangEditorGuide) {
						this.editorGuide = new E(this.$refs.wangEditorGuide);
						this.editorGuide.config.placeholder = '请输入操作步骤内容';
						this.editorGuide.config.onchange = (html) => {
							this.editModel.operationSteps = html;
							if (this.$refs.formRef && html) {
								this.$refs.formRef.validateField('operationSteps');
							}
						};
						this.editorGuide.create();
						this.editorGuide.txt.html(this.editModel.operationSteps || '');
					}
				});
			},
			destroyEditorGuide() {
				if (this.editorGuide) {
					this.editModel.operationSteps = this.editorGuide.txt.html();
					this.editorGuide.destroy();
					this.editorGuide = null;
				}
			},
			initEditorFaq() {
				this.$nextTick(() => {
					if (this.$refs.wangEditorFaq) {
						this.editorFaq = new E(this.$refs.wangEditorFaq);
						this.editorFaq.config.placeholder = '请输入答案内容';
						this.editorFaq.config.onchange = (html) => {
							this.faqModel.operationSteps = html;
							if (this.$refs.formRef && html) {
								this.$refs.formRef.validateField('operationSteps');
							}
						};
						this.editorFaq.create();
						this.editorFaq.txt.html(this.faqModel.operationSteps || '');
					}
				});
			},
			destroyEditorFaq() {
				if (this.editorFaq) {
					this.faqModel.operationSteps = this.editorFaq.txt.html();
					this.editorFaq.destroy();
					this.editorFaq = null;
				}
			},
			handleGuideCancel() {
				this.destroyEditorGuide();
				this.editModel.flag = false;
			},
			scriptEdit() {
				const lang = this.filterData.lang || 'CH';
				getBottomWordingApi({ type: 'COMPLAINT', lang }).then((res) => {
					if (res.resultStatus) {
						const data = res.resultData || {};
						let parsed = { topTitle: '', topContent: '', bottomTitle: '', bottomContent: '' };
						if (data.configValue) {
							try {
								parsed = JSON.parse(data.configValue);
							} catch(e) {
								console.log(e);
							}
						}
						this.tipsModel = {
							flag: true,
							title: '投诉指南页面话术编辑',
							configId: data.configId,
							topTitle: parsed.topTitle || '',
							topContent: parsed.topContent || '',
							bottomTitle: parsed.bottomTitle || '',
							bottomContent: parsed.bottomContent || '',
							onOk: this.sureScript,
						};
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			sureScript() {
				const configValue = JSON.stringify({
					topTitle: this.tipsModel.topTitle,
					topContent: this.tipsModel.topContent,
					bottomTitle: this.tipsModel.bottomTitle,
					bottomContent: this.tipsModel.bottomContent,
				});
				const params = {
					configId: this.tipsModel.configId,
					configValue,
					type: 'COMPLAINT',
					lang: this.filterData.lang || 'CH',
				};
				saveBottomWordingApi(params).then((res) => {
					if (res.resultStatus) {
						this.$message.success('保存成功');
						this.tipsModel.flag = false;
					}
				}).catch((err) => {
					console.log(err);
					this.$message.error('保存失败');
				});
			},
			sureDelete(record) {
				deleteComplaintGuideApi({
					complaintGuideId: record.complaintGuideId,
				}).then((res) => {
					if (res.resultStatus) this.$message.success("删除成功");
				}).catch((error) => {
					console.log(error);
				}).finally(() => {
					this.getData(this.pageInfo.current);
				});
			},
			handleUploadThumbnail() {},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
	/* wangEditor 下拉菜单裁剪修复 */
	.w-e-toolbar {
		z-index: 99999 !important;
	}
</style>
